// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import { library, dom } from '@fortawesome/fontawesome-svg-core'

// import used icons
import { faAngleDown, faAngleRight, faTimes } from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add( faAngleDown, faAngleRight, faTimes);
// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

jQuery(document).ready(function($) {
  $(window).on('scroll load resize', function () {
      $('body').toggleClass('scrolling', ($(window).scrollTop() > 50));
   });

  $('.search-toggler').on('click', function(event) {
    event.preventDefault();
    $('.site-search').slideToggle(300);
  });

  $('.category-navigation-toggler').on('click', function(event) {
    event.preventDefault();
    $('#category-navigation .nav').slideToggle(300);
  });

  // Submit sorting form on product archive
  $( '.woocommerce-ordering' ).on( 'change', 'select.postperpage', function() {
    $( this ).closest( 'form' ).trigger( 'submit' );
  });

  // Plus minus buttons on product page
  $(document).on( 'click', 'button.qty-plus, button.qty-minus', function() {
     var qty = $( this ).parent( '.quantity' ).find( '.qty' );
     var val = parseFloat(qty.val());
     var max = parseFloat(qty.attr( 'max' ));
     var min = parseFloat(qty.attr( 'min' ));
     var step = parseFloat(qty.attr( 'step' ));

     if ( $( this ).is( '.qty-plus' ) ) {
        if ( max && ( max <= val ) ) {
           qty.val( max ).change();
        } else {
           qty.val( val + step ).change();
        }
     } else {
        if ( min && ( min >= val ) ) {
           qty.val( min ).change();
        } else if ( val > 1 ) {
           qty.val( val - step ).change();
        }
     }

  });

  // Update minicart on clicking buttons and stuff
  $('.ajax_add_to_cart, .single_add_to_cart_button, .remove_from_cart_button, td.product-remove .remove, .woocommerce-cart-form .actions button').on('click', function() {
    setTimeout(function(){
      $.post(/*eslint-disable-next-line*/
        woocommerce_params.ajax_url,
        {'action': 'alapeite_update_mini_cart'},
        function(response) {
          $('#mini-cart .widget_shopping_cart_content').html(response);

          // Update header total with cool fade effect
          var newtotal = $('#mini-cart .woocommerce-mini-cart__total.total .woocommerce-Price-amount.amount bdi').html();
          console.log(newtotal);
          $('.cart-toggler .cart-total-display').fadeOut('fast', function() {
            if( typeof newtotal === 'undefined' ) {
              newtotal = '0,00&nbsp;<span class="woocommerce-Price-currencySymbol">€</span>';
            }

            $(this).html(newtotal).fadeIn('fast');
          });

        }
      );
    }, 1000);
  });
});


// WEBPACK FOOTER //
// ./scripts/main.js